import {UserActionType, UserState} from "./types";

const initialState: UserState = {
    user: null,
    isAuth: false,
    loading: false,
    message: "",
    profile: null,
    status: null,
    allUsers: null,
    allRoles: []
};
const UserReducer = (state = initialState, action: any): UserState => {
    switch (action.type) {
        case UserActionType.START_REQUEST:
            return { ...state, loading: true };
        case UserActionType.USER_LOADED:
            return { ...state, loading: false, message: action.payload };
        case UserActionType.PROFILE_LOADED:
            return { ...state, loading: false, profile: action.payload };
        case UserActionType.STATUS_LOADED:
            return { ...state, loading: false, status: action.payload };
        case UserActionType.LOGGED_IN:
            return { ...state, loading: false, isAuth: true, user: action.payload.decodedToken, message: action.payload.message};
        case UserActionType.LOGGED_OUT:
            return { ...state, loading: false, isAuth: false, user: null, message: ""};
        case UserActionType.FINISH_REQUEST:
            return { ...state, loading: false };
        case UserActionType.USER_REGISTERED:
            return { ...state, loading: false, message: action.payload.message };
        case UserActionType.GET_ALL_USERS:
            return { ...state, loading: false, allUsers: action.payload };
        case UserActionType.GET_ALL_ROLES:
            return { ...state, loading: false, allRoles: action.payload };
        default:
            return state;
    }
};

export default UserReducer;
